export default function regexTest(str, regVal, responseText) {
    var regex = new RegExp(regVal, "g");
    return !responseText ? regex.test(str) : regex.test(str) || responseText;
}